module.exports = __webpack_public_path__ + "resources/sms-finance.png";